var _desc, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQdrant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 640,
    height: 480,
    viewBox: "0 0 640 480",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.6.6")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.26 0 0 1.26 318.23 240.15)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.24 0 0 2.24 109.04 42.67)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(125,140,181)",
      fillRule: "evenodd",
      opacity: 1
    },
    transform: " translate(-114.67, -95.25)",
    d: "m 100.83 58.616 l 8.7164 -7.5544 l 22.44 -12.96 v 101.35 l -22.44 12.951 l -12.192 -14.479 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.24 0 0 2.24 -0.01 -105.84)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(178,191,232)",
      fillRule: "evenodd",
      opacity: 1
    },
    transform: " translate(-65.99, -28.95)",
    d: "m 131.98 38.1 l -22.44 12.96 l -19.968 1.5727 l -17.006 -2.9318 l -34.205 2.8206 l -25.621 5.3845 l -12.741 -19.806 l 32.99 -19.05 l 33 -19.05 l 32.991 19.05 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.24 0 0 2.24 -58.9 42.67)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(217,226,255)",
      fillRule: "evenodd",
      opacity: 1
    },
    transform: " translate(-39.7, -95.25)",
    d: "m 0 38.1 l 22.44 12.96 l 20.221 39.57 l 14.616 14.904 l 22.116 30.044 l -13.403 16.822 l -33 -19.051 l -32.991 -19.05 v -76.2",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.24 0 0 2.24 32.59 118.09)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(125,140,181)",
      fillRule: "evenodd",
      opacity: 1
    },
    transform: " translate(-80.54, -128.92)",
    d: "m 86.725 105.44 l -20.734 21.054 v 25.91 l 21.11 -12.18 l 7.9897 -29.456",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.24 0 0 2.24 0 -9.56)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(178,191,232)",
      fillRule: "evenodd",
      opacity: 1
    },
    transform: " translate(-65.99, -71.93)",
    d: "m 65.991 100.58 l -21.11 -36.558 l 3.6767 -14.176 l 18.347 -6.5603 l 18.082 7.091 l 2.1139 13.645 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.24 0 0 2.24 -34.7 15.69)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(217,226,255)",
      fillRule: "evenodd",
      opacity: 1
    },
    transform: " translate(-50.5, -83.2)",
    d: "m 44.881 64.022 l 21.11 12.18 v 24.38 l -12.238 1.8059 l -18.74 -10.187 l 4.0273 -22.313 l 5.84 -5.8662",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.24 0 0 2.24 36.4 15.13)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(125,140,181)",
      fillRule: "evenodd",
      opacity: 1
    },
    transform: " translate(-82.24, -82.95)",
    d: "m 65.991 76.2 l 21.11 -12.179 l 9.4348 9.6634 l 1.9589 20.474 l -14.573 7.7306 l -17.93 -1.3083 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.24 0 0 2.24 0 29.03)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(201,21,64)",
      fillRule: "evenodd",
      opacity: 1
    },
    transform: " translate(-65.99, -89.16)",
    d: "m 87.101 140.22 l 22.44 12.181 v -101.34 l -21.78 -12.57 l -21.77 -12.57 l -21.78 12.57 l -21.77 12.57 v 50.289 l 21.77 12.57 l 21.78 12.571 l 21.11 -12.191 z m 0 -51.83 l -21.11 12.19 l -21.11 -12.19 v -24.37 l 21.11 -12.19 l 21.11 12.19 v 24.37",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.24 0 0 2.24 -23.5 70.11)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_paint0_linear_425_139_5",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 62.578,
    y1: 109.32,
    x2: 41.666,
    y2: 109.32
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(255,51,100)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(201,21,64)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_paint0_linear_425_139_5)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-55.5, -107.5)",
    d: "m 66 126.5 v -25.914 l -21 -12.086 v 25.871 z",
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQdrant);
export default __webpack_public_path__ + "static/media/Qdrant.72b63539e11816820be60a8030116fd9.svg";
export { ForwardRef as ReactComponent };